export default {
  free_menu_items: 'Gratis freigeschaltet',
  discount_badge: '{{value}} Rabatt',
  available_at_badge: 'Verfügbar {{schedule}}',
  restricted_tooltip: 'Verfügbar {{schedule}} — ändere oben die Abholzeit, um zu bestellen.',
};
